import * as actionTypes from "../../lib/constants/actionTypes";

const initialState = {
  transLogData: null,
  filterData: null,
  transDetailsData: null,
};

const transLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TRANSACTION_LOG_DATA:
      return {
        ...state,
        transLogData: action.payload
      };

    case actionTypes.TRANSACTION_DETAILS:
      return{
        ...state,
        transDetailsData: action.payload
      }

    case actionTypes.FILTER_DATA:
      return {
        ...state,
        filterData: action.payload
      };

    default:
      return state;
  }
};

export default transLogReducer;